import { render } from "./ModalCreateFactory.vue?vue&type=template&id=c94e2d5e"
import script from "./ModalCreateFactory.vue?vue&type=script&lang=js"
export * from "./ModalCreateFactory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__